var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",staticClass:"notranslate",attrs:{"id":"app","translate":"no"}},[(_vm.$store.state.isLoadingActive)?_c('loading'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }